import { useState } from "react";
import { Panel, AddButton, Empty } from "@/components/Bits";
import { DocumentoList } from "@/components/DocumentoList";
import { DocumentoUploadDialog } from "@/components/DocumentoUploadDialog";
import { useAuth } from "@/context/AuthContext";
import { useFetch } from "@/lib/useFetch";

export const DocumentosPanel = ({ filter, fixed }) => {
  const { user } = useAuth();
  const { data, reload } = useFetch("/documentos", filter);
  const [open, setOpen] = useState(false);
  return (
    <Panel title={`Documentos (${data?.length ?? 0})`} testId="documentos-panel"
      action={user.role !== "cliente" && <AddButton small onClick={() => setOpen(true)} data-testid="documentos-panel-add">Documento</AddButton>}>
      {data?.length === 0 ? <Empty>Nenhum documento anexado.</Empty> : <DocumentoList items={data || []} onChange={reload} />}
      <DocumentoUploadDialog open={open} onOpenChange={setOpen} fixed={fixed} onSaved={reload} />
    </Panel>
  );
};
